export function isDarkMode(): boolean {
  if (localStorage.getItem("darkMode") === "true") {
    return true;
  }
  return false;
}
